module.exports = __webpack_public_path__ + "static/media/HollowCircleSectionGeometry.1c78695e.svg";